module.exports = __webpack_public_path__ + "img/fengkong.28509a4a.png";